import { useLocalization as e } from "./localization/index.js";
import t from "./SchemaGlyphPuck.vue.js";
import n from "./SchemaEnumPropertyItem.vue.js";
import { Fragment as r, computed as i, createBlock as a, createCommentVNode as o, createElementBlock as s, createElementVNode as c, createTextVNode as l, createVNode as u, defineComponent as d, openBlock as f, ref as p, renderList as m, toDisplayString as h, unref as g } from "vue";
import { resolve as _ } from "@scalar/workspace-store/resolve";
import { isArraySchema as v } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/SchemaEnums.vue?vue&type=script&setup=true&lang.ts
var y = {
	key: 0,
	class: "property-enum property-enum--tree mt-2 rounded-(--scalar-radius-lg) border"
}, b = { class: "property-enum-header text-c-2 px-3 py-2 text-sm capitalize" }, x = {
	key: 0,
	class: "text-c-2 border-t px-3 py-2 text-sm"
}, S = {
	key: 1,
	class: "property-enum-chip-list flex flex-wrap gap-1 border-t px-3 py-2",
	role: "list"
}, C = {
	key: 2,
	class: "property-enum-values-card",
	role: "list"
}, w = {
	key: 1,
	class: "border-t"
}, T = 12, E = 8, D = 24, O = " ", k = /*@__PURE__*/ d({
	__name: "SchemaEnums",
	props: {
		value: {},
		propertyNames: {
			type: Boolean,
			default: !1
		}
	},
	setup(d) {
		let { translate: k } = e(), A = i(() => {
			if (d.value) return d.value.enum ? d.value : v(d.value) ? _.schema(d.value.items) : void 0;
		}), j = i(() => A.value?.enum ?? []), M = i(() => j.value.length > T), N = i(() => M.value ? E : j.value.length), P = i(() => !d.propertyNames && j.value.length > 0 && !M.value && j.value.every((e, t) => z(e, t).length <= D) && !F.value), F = i(() => j.value.some((e, t) => R(e, t) !== void 0)), I = i(() => j.value.slice(0, N.value)), L = i(() => j.value.slice(N.value)), R = (e, t) => {
			let n = A.value, r = n?.["x-enumDescriptions"] ?? n?.["x-enum-descriptions"];
			if (r) {
				if (Array.isArray(r)) return r[t] || void 0;
				if (typeof r == "object" && r) return r[String(e)] || void 0;
			}
		}, z = (e, t) => {
			let n = A.value?.["x-enum-varnames"] ?? A.value?.["x-enumNames"], r = Array.isArray(n) ? n[t] : void 0;
			return r ? `${e}${O}=${O}${r}` : String(e);
		}, B = p(!1), V = () => {
			B.value = !B.value;
		};
		return (e, i) => A.value?.enum === void 0 ? o("", !0) : (f(), s("div", y, [c("div", b, h(d.propertyNames ? g(k)("schema.propertyNames") : g(k)("schema.values")), 1), j.value.length === 0 ? (f(), s("p", x, h(g(k)("schema.noAllowedValues")), 1)) : P.value ? (f(), s("div", S, [(f(!0), s(r, null, m(j.value, (e, t) => (f(), s("span", {
			key: t,
			class: "property-enum-chip font-code text-c-2 rounded-(--scalar-radius-lg) border px-1.5 py-px text-(length:--scalar-mini)",
			role: "listitem"
		}, h(z(e, t)), 1))), 128))])) : (f(), s("ul", C, [
			(f(!0), s(r, null, m(I.value, (e, t) => (f(), a(n, {
				key: t,
				description: R(e, t),
				label: z(e, t)
			}, null, 8, ["description", "label"]))), 128)),
			M.value && B.value ? (f(!0), s(r, { key: 0 }, m(L.value, (e, t) => (f(), a(n, {
				key: N.value + t,
				description: R(e, N.value + t),
				label: z(e, N.value + t)
			}, null, 8, ["description", "label"]))), 128)) : o("", !0),
			M.value ? (f(), s("li", w, [c("button", {
				class: "enum-toggle-button group/tree-control text-c-2 hover:text-c-1 flex w-full cursor-pointer items-center gap-1.5 px-3 py-2 text-sm",
				type: "button",
				onClick: V
			}, [u(t, {
				floating: !1,
				open: B.value
			}, null, 8, ["open"]), l(" " + h(B.value ? g(k)("schema.hideValues") : g(k)("schema.showAllValues")), 1)])])) : o("", !0)
		]))]));
	}
});
//#endregion
export { k as default };

//# sourceMappingURL=SchemaEnums.vue_vue_type_script_setup_true_lang.js.map